import Phaser from "phaser";

export default class MainScene extends Phaser.Scene {
  constructor() {
    super("MainScene");
    this.state = {};
    this.wallsGroup = null;
    this.renderTexture = null;
    this.playerVision = null;
    this.logs = [];

    this.maze = [
      [1, 1, 1, 1, 1, 1, 1, 1, 1, 2, 2, 2, 1, 1, 2, 2, 2, 2, 2, 1, 1],
      [1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1],
      [1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1],
      [1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1],
      [1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1],
      [1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1],
      [1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1],
      [1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1],
      [1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1],
      [1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1],
      [1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1],
      [1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1],
      [1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1],
      [1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1],
      [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
    ];
  }

  preload() {
    this.load.scenePlugin({
      key: "rexuiplugin",
      url: "https://raw.githubusercontent.com/rexrainbow/phaser3-rex-notes/v3.xx/dist/rexuiplugin.min.js",
      sceneKey: "rexUI",
    });
    this.load.audio("bgmusic", "/assets/audio/bgmusic.mp3");
    this.load.audio("last10sec", "/assets/audio/last10sec.mp3");
    this.load.audio("heartbeat", "/assets/audio/heartbeat.mp3");
    this.load.audio("countdown", "/assets/audio/countdown.wav");
    this.load.audio("hit001", "/assets/audio/hit001.wav");
    this.load.audio("hit002", "/assets/audio/hit002.wav");
    this.load.audio("hit003", "/assets/audio/hit003.wav");
    this.load.audio("hit004", "/assets/audio/hit004.wav");
    this.load.image("stone", "/assets/sprites/stone.png");
    this.load.image("path", "/assets/sprites/path.png");
    this.load.image("wood", "/assets/sprites/wood.png");
    this.load.image("soil", "/assets/sprites/soil.png");
    this.load.image("player", "/assets/sprites/player.png");
    this.load.image("vision", "/assets/sprites/vision.png");
    this.load.font("Kenney Thick", "/assets/fonts/KenneyThick.ttf");
    this.load.spritesheet("playeranim", "assets/spritesheets/playeranim.png", {
      frameWidth: 32,
      frameHeight: 32,
    });
  }

  create() {
    const self = this;
    let { width, height } = self.sys.game.canvas;

    let musicState = getCookie("music") || "on";

    //BACKGROUND
    self.wallsGroup = self.physics.add.staticGroup();

    self.buildMaze(self);

    self.hitSounds = [
      self.sound.add("hit001"),
      self.sound.add("hit002"),
      self.sound.add("hit003"),
      self.sound.add("hit004"),
    ];

    self.bgMusic = self.sound.add("bgmusic", { volume: 0.75 });
    self.bgMusic.pause();

    self.last10secMusic = self.sound.add("last10sec", { volume: 0.75 });
    self.last10secMusic.pause();

    if (musicState === "on") {
      self.bgMusic.volume = 0.75;
      self.last10secMusic.volume = 0.75;
    } else {
      self.bgMusic.volume = 0;
      self.last10secMusic.volume = 0;
    }
    // Buton ekleme
    self.musicButton = this.add
      .text(
        width - 90,
        3,
        musicState === "on" ? "🔊 Music Off" : "🔈 Music On",
        {
          fontSize: "14px",
          fill: "#fff",
          fontFamily: "Open Sans",
        }
      )
      .setDepth(2)
      .setInteractive();

    // Butona tıklanınca müziği aç/kapat
    self.musicButton.on("pointerdown", () => {
      if (self.bgMusic.volume > 0) {
        self.bgMusic.volume = 0;
        self.last10secMusic.volume = 0;
        self.musicButton.setText("🔈 Music On");
        setCookie("music", "off", 7);
      } else {
        self.bgMusic.volume = 0.75;
        self.last10secMusic.volume = 0.75;
        self.musicButton.setText("🔊 Music Off");
        setCookie("music", "on", 7);
      }
    });

    const walk = {
      key: "walk",
      frames: this.anims.generateFrameNumbers("playeranim"),
      framerate: 16,
      repeat: -1,
    };
    this.anims.create(walk);

    self.startButton = self.add
      .text(width / 2, height / 2, "Start", {
        fill: "#A63F03",
        fontSize: "80px",
        fontStyle: "bold",
        fontFamily: "Kenney Thick",
        stroke: "#D97218",
        strokeThickness: 5,
        shadow: {
          color: "#F2BE5C",
          fill: true,
          offsetX: 0,
          offsetY: 10,
          blur: 0,
        },
      })
      .setOrigin(0.5, 0.5)
      .setDepth(2)
      .setVisible(false);
    self.startButton.setInteractive();

    self.countDown = self.add
      .text(width / 2, height / 2, "", {
        fill: "#F23005",
        fontSize: "90px",
        fontStyle: "bold",
        fontFamily: "Kenney Thick",
        stroke: "#F25C05",
        strokeThickness: 5,
      })
      .setOrigin(0.5, 0.5)
      .setDepth(2)
      .setVisible(false);

    this.timeText = this.add
      .text(width / 2, 27, "", {
        fontSize: "32px",
        fill: "#fff",
        fontFamily: "Kenney Thick",
      })
      .setOrigin(0.5, 0.5)
      .setDepth(2);

    this.infoText = this.rexUI.add
      .BBCodeText(width - 330, 45, "", {
        fontSize: "9px",
        fill: "#fff",
        fontFamily: "Kenney Thick",
        lineSpacing: 5,
      })
      .setOrigin(0, 1)
      .setDepth(2);

    const barrel = this.timeText.preFX.addBarrel(1);
    this.countDownTween = this.add.tween({
      duration: 400,
      repeatDelay: 200,
      targets: barrel,
      ease: Phaser.Math.Easing.Elastic.InOut,
      amount: 1.5,
      yoyo: true,
      repeat: -1,
      onRepeat: () => {
        this.sound.play("heartbeat");
      },
      onStart: () => {
        this.sound.play("heartbeat");
      },
    });
    this.countDownTween.pause();

    //CREATE SOCKET
    this.socket = io();

    //LAUNCH WAITING ROOM
    self.scene.launch("WaitingRoom", { socket: self.socket });

    // CREATE OTHER PLAYERS GROUP
    this.otherPlayers = this.physics.add.group({
      immovable: true,
    });

    // JOINED ROOM - SET STATE
    this.socket.on("setState", function (state) {
      const { roomKey, players, numPlayers } = state;
      self.physics.resume();

      // STATE
      self.state.roomKey = roomKey;
      self.state.players = players;
      self.state.numPlayers = numPlayers;
      self.maze = state.maze;
      self.buildMaze(self);
      self.startButton.visible = Object.keys(players)[0] === self.socket.id;
    });

    // PLAYERS
    this.socket.on("currentPlayers", function (arg) {
      const { players, numPlayers } = arg;
      self.state.numPlayers = numPlayers;
      Object.keys(players).forEach(function (id) {
        if (players[id].playerId === self.socket.id) {
          self.addPlayer(self, players[id]);
        } else {
          self.addOtherPlayers(self, players[id]);
        }
      });
      self.physics.add.collider(self.player, self.wallsGroup);
      self.physics.add.collider(
        self.player,
        self.otherPlayers,
        (p, o) => self.checkCollision(p, o, self),
        null,
        this
      );
    });

    this.socket.on("newPlayer", function (arg) {
      const { playerInfo, numPlayers, players } = arg;
      self.addOtherPlayers(self, playerInfo);
      self.state.numPlayers = numPlayers;
      self.state.players = players;
      self.logs.push(
        `[color=lime]${playerInfo.playerName} join the game[/color]`
      );
      self.infoText.setText(self.logs);
    });

    this.socket.on("playerMoved", function (playerInfo) {
      self.otherPlayers.getChildren().forEach(function (otherPlayer) {
        if (playerInfo.playerId === otherPlayer.playerId) {
          otherPlayer.setPosition(playerInfo.x, playerInfo.y);
          otherPlayer.angle = playerInfo.angle;
          otherPlayer.playerNameText.setPosition(
            playerInfo.x,
            playerInfo.y - 25
          );

          if (playerInfo.isMoving) {
            otherPlayer.anims.play("walk", true);
          } else {
            otherPlayer.anims.stop();
          }
        }
      });
    });

    this.cursors = this.input.keyboard.createCursorKeys();

    self.startButton.on("pointerdown", () => {
      let randomIndex = Math.floor(Math.random() * self.state.numPlayers);
      let randomPlayerId = Object.keys(self.state.players)[randomIndex];

      self.state.players[randomPlayerId].isImposter = true;

      self.socket.emit("startGame", {
        roomKey: self.state.roomKey,
        playerId: randomPlayerId,
      });
    });

    this.socket.on("gameStarted", function (players) {
      self.state.players = players;
      let imposterPlayerId = Object.values(players).find(
        (player) => player.isImposter
      ).playerId;
      self.bgMusic.play({ delay: 1 });
      self.gameStart(self, imposterPlayerId);
    });

    this.socket.on("imposterChanged", function (players) {
      self.state.players = players;

      Object.values(players).forEach((player) => {
        if (player.isImposter) {
          if (player.playerId === self.socket.id)
            self.player.setTint("0xff0000");

          self.otherPlayers.getChildren().forEach((otherPlayer) => {
            if (otherPlayer.playerId === player.playerId) {
              otherPlayer.setTint("0xff0000");
            } else otherPlayer.setTint("0xffffff");
          });
        }
      });

      self.playRandomHitSound(self);
    });

    this.socket.on("roundStarted", (time) => {
      this.roundTime = time;
      this.updateTimer(self);
    });

    this.socket.on("roundTimeUpdate", (time) => {
      this.roundTime = time;
      let imposterPlayer = Object.values(self.state.players).find(
        (player) => player.isImposter
      );
      imposterPlayer.imposterTime++;

      if (time === 10) {
        this.last10secMusic.play();
      }
      if (time <= 10) {
        this.countDownTween.resume();
        this.timeText.setTint(0xf23005);
      }

      this.updateTimer(self);
    });

    this.socket.on("roundEnded", () => {
      let counter = 0;
      Object.values(self.state.players).forEach((player) => {
        if (player.isImposter) player.imposterTime += 15;
      });

      let sortedPlayers = Object.values(self.state.players).sort(
        (a, b) => a.imposterTime - b.imposterTime
      );

      let sortedPlayerNamesText = "";
      let sortedScoresText = "";
      sortedPlayers.forEach((player) => {
        let penaltyText = player.isImposter ? "added 15 sec penalty" : "";
        let playerText = `[color=white][size=16]${player.playerName}[/size][/color]\n`;
        let scoreText = `[color=white][size=16]${player.imposterTime}[/size] [size=8]${penaltyText}[/size][/color]\n`;
        if (
          counter === 0 ||
          player.imposterTime === sortedPlayers[0].imposterTime
        ) {
          playerText = `[color=lime][size=20]${player.playerName}[/size][/color]\n`;
          scoreText = `[color=lime][size=20]${player.imposterTime}[/size] [size=8]${penaltyText}[/size][/color]\n`;
        }
        if (counter === this.state.numPlayers - 1) {
          playerText = `[color=red][size=16]${player.playerName}[/size][/color]\n`;
          scoreText = `[color=red][size=16]${player.imposterTime}[/size] [size=8]${penaltyText}[/size][/color]\n`;
        }
        sortedPlayerNamesText += playerText;
        sortedScoresText += scoreText;
        counter++;
      });

      this.rexUI.add
        .BBCodeText(width / 2 - 100, height / 2, sortedPlayerNamesText, {
          fontSize: "20px",
          fontFamily: "Kenney Thick",
          align: "left",
        })
        .setOrigin(0.5)
        .setDepth(2);

      this.rexUI.add
        .BBCodeText(width / 2 + 100, height / 2, sortedScoresText, {
          fontSize: "20px",
          fontFamily: "Kenney Thick",
          align: "left",
        })
        .setOrigin(0.5)
        .setDepth(2);

      this.countDownTween.pause();
      this.timeText.setText("GG");

      self.reStartButton = self.add
        .text(width / 2, height / 2 - 240, "Restart", {
          fill: "#F23005",
          fontSize: "35px",
          fontStyle: "bold",
          fontFamily: "Kenney Thick",
          stroke: "#F25C05",
          strokeThickness: 2,
        })
        .setOrigin(0.5, 0.5);
      self.reStartButton.setInteractive();
      self.reStartButton.on("pointerdown", () => {
        window.location.reload();
      });
    });

    // DISCONNECT
    this.socket.on("disconnected", function (arg) {
      const { playerId, numPlayers, hostPlayerId, isGameStarted } = arg;
      self.state.numPlayers = numPlayers;
      self.otherPlayers.getChildren().forEach(function (otherPlayer) {
        if (playerId === otherPlayer.playerId) {
          otherPlayer.playerNameText.destroy();
          otherPlayer.destroy();
        }
      });
      self.logs.push(
        `[color=red]${self.state.players[playerId].playerName} left the game[/color]`
      );
      self.infoText.setText(self.logs);
      self.startButton.visible =
        hostPlayerId === self.socket.id && isGameStarted === false;
    });
  }
  updateTimer(scene) {
    scene.timeText.setText(scene.roundTime);
  }
  gameStart(scene, randomPlayerId) {
    scene.startButton.disableInteractive();
    scene.startButton.visible = false;
    scene.countDown.visible = true;
    let timer = 3;
    let intervalId = setInterval(function () {
      scene.sound.play("countdown");
      if (timer === 0) {
        clearInterval(intervalId);
        scene.countDown.visible = false;
        scene.setImposter(null, randomPlayerId, scene);
        scene.fadeToBlack(scene);

        scene.socket.emit("startRound", {
          roomKey: scene.state.roomKey,
        });
      }
      scene.countDown.setText(timer--);
    }, 1000);
  }

  setImposter(playerId, newImposterId, scene) {
    if (playerId && scene.state.players[playerId].isImposter) {
      scene.socket.emit("changeImposter", {
        roomKey: scene.state.roomKey,
        imposterId: playerId,
        newImposterId: newImposterId,
        oldImposterTime: scene.state.players[playerId].imposterTime,
      });

      scene.state.players[playerId].isImposter = false;
      scene.state.players[newImposterId].isImposter = true;

      scene.player.setTint("0xffffff");
      scene.otherPlayers.getChildren().forEach((otherPlayer) => {
        if (otherPlayer.playerId === newImposterId)
          otherPlayer.setTint("0xff0000");
      });
      scene.playRandomHitSound(scene);
      return;
    }

    if (newImposterId === scene.socket.id) scene.player.setTint("0xff0000");
    else
      scene.otherPlayers
        .getChildren()
        .find((otherPlayer) => otherPlayer.playerId === newImposterId)
        .setTint("0xff0000");
  }

  fadeToBlack(scene) {
    let { width, height } = scene.sys.game.canvas;
    const rt = scene.make
      .renderTexture(
        {
          width,
          height,
        },
        true
      )
      .setOrigin(0, 0);
    // fill it with black
    rt.fill(0x000000, 1);
    // draw the floorLayer into it
    rt.draw(scene.wallsGroup);
    // set a dark blue tint
    rt.setTint(0x0a2948);
    scene.renderTexture = rt;

    const vision = scene.make.image({
      x: scene.player.x,
      y: scene.player.y,
      key: "vision",
      add: false,
    });
    vision.scale = 3;

    scene.renderTexture.mask = new Phaser.Display.Masks.BitmapMask(
      scene,
      vision
    );
    scene.renderTexture.mask.invertAlpha = true;
    scene.playerVision = vision;
  }

  checkCollision(player, otherPlayer, scene) {
    if (scene.state.players[player.playerId].isImposter) {
      scene.setImposter(player.playerId, otherPlayer.playerId, scene);
    }
  }

  update() {
    //MOVEMENT
    if (this.player) {
      const speed = 225;
      let moving = false;
      // Stop any previous movement from the last frame
      this.player.body.setVelocity(0);
      // Horizontal movement
      if (this.cursors.left.isDown) {
        this.player.body.setVelocityX(-speed);
        this.player.angle = -90;
        moving = true;
      } else if (this.cursors.right.isDown) {
        this.player.body.setVelocityX(speed);
        this.player.angle = 90;
        moving = true;
      }
      // Vertical movement
      if (this.cursors.up.isDown) {
        this.player.body.setVelocityY(-speed);
        this.player.angle = 0;
        moving = true;
      } else if (this.cursors.down.isDown) {
        this.player.body.setVelocityY(speed);
        this.player.angle = 180;
        moving = true;
      }

      if (this.cursors.left.isDown && this.cursors.up.isDown) {
        this.player.angle = -45;
      }
      if (this.cursors.left.isDown && this.cursors.down.isDown) {
        this.player.angle = -135;
      }
      if (this.cursors.right.isDown && this.cursors.up.isDown) {
        this.player.angle = 45;
      }
      if (this.cursors.right.isDown && this.cursors.down.isDown) {
        this.player.angle = 135;
      }

      if (
        this.cursors.left.isDown ||
        this.cursors.right.isDown ||
        this.cursors.up.isDown ||
        this.cursors.down.isDown
      ) {
        this.player.anims.play("walk", true);
      } else {
        this.player.anims.stop();
      }

      // Normalize and scale the velocity so that player can't move faster along a diagonal
      this.player.body.velocity.normalize().scale(speed);
      this.player.playerNameText.setPosition(this.player.x, this.player.y - 25);

      // emit player movement
      var x = this.player.x;
      var y = this.player.y;

      if (this.playerVision) {
        this.playerVision.x = x;
        this.playerVision.y = y;
      }

      if (
        this.player.oldPosition &&
        (x !== this.player.oldPosition.x || y !== this.player.oldPosition.y)
      ) {
        this.moving = true;
        this.socket.emit("playerMovement", {
          x: this.player.x,
          y: this.player.y,
          angle: this.player.angle,
          roomKey: this.state.roomKey,
          isMoving: moving,
        });
      }
      // save old position data
      this.player.oldPosition = {
        x: this.player.x,
        y: this.player.y,
      };
    }
  }

  buildMaze(scene) {
    // Labirenti oluşturma
    const tileSize = 48;
    for (let y = 0; y < scene.maze.length; y++) {
      for (let x = 0; x < scene.maze[y].length; x++) {
        if (scene.maze[y][x] === 1) {
          // 1, taş (duvar) anlamına gelir
          let stone = scene.wallsGroup.create(
            x * tileSize + 24,
            y * tileSize + 24,
            "stone"
          );
          stone.setTint("0x999999");
          stone.setDisplaySize(tileSize, tileSize);
        } else if (scene.maze[y][x] === 2) {
          // 1, taş (duvar) anlamına gelir
          let wood = scene.wallsGroup.create(
            x * tileSize + 24,
            y * tileSize + 24,
            "wood"
          );
          wood.setTint("0x999999");
          wood.setDisplaySize(tileSize, tileSize);
        } else {
          let soil = scene.add.image(
            x * tileSize + 24,
            y * tileSize + 24,
            "soil"
          );
          soil.setTint("0x333333");
          soil.setDisplaySize(tileSize, tileSize);
        }
      }
    }
  }

  addPlayer(scene, playerInfo) {
    scene.player = scene.physics.add
      .sprite(playerInfo.x, playerInfo.y, "playeranim")
      .setOrigin(0.5, 0.5)
      .setSize(32, 32, true);
    scene.player.angle = 90;

    scene.player.playerId = playerInfo.playerId;

    scene.player.playerNameText = scene.add.text(
      playerInfo.x,
      playerInfo.y - 25,
      playerInfo.playerName,
      {
        fontSize: 16,
        fill: "#ffffff",
      }
    );
    scene.player.playerNameText.setOrigin(0.5, 0.5);
  }

  addOtherPlayers(scene, playerInfo) {
    const otherPlayer = scene.add
      .sprite(playerInfo.x, playerInfo.y, "playeranim")
      .setOrigin(0.5, 0.5)
      .setSize(32, 32);
    otherPlayer.angle = 90;

    otherPlayer.playerId = playerInfo.playerId;

    otherPlayer.playerNameText = scene.add.text(
      playerInfo.x,
      playerInfo.y - 25,
      playerInfo.playerName,
      {
        fontSize: 16,
        fill: "#ffffff",
      }
    );
    otherPlayer.playerNameText.setOrigin(0.5, 0.5);

    scene.otherPlayers.add(otherPlayer);
  }

  playRandomHitSound(scene) {
    let randomIndex = Phaser.Math.Between(0, scene.hitSounds.length - 1);
    scene.hitSounds[randomIndex].play();
  }
}
